import { supabase } from "../lib/supabase"

export function getUser() {
  return supabase.auth.getUser()
}
